// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dv-el-select-input{width:60px;font-size:12px}.dv-el-select-input .el-input__inner{padding-left:5px}", ""]);
// Exports
module.exports = exports;
